module.exports = new __parcel__URL__("posterama.28cb5dd1.webp").toString();